export default __webpack_public_path__ + "images/a4a937f8756747628e2c08c1e764a605.png";